import { sqliteTable, text, integer, uniqueIndex, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// record_shares — Document sharing (แชร์ document เฉพาะคน)
// ============================================================================
export const recordShares = sqliteTable("core_record_shares", {
  id: text("id").primaryKey(), // ULID
  module: text("module").notNull(), // "car-rental", "fleet", "accounting"
  doctype: text("doctype").notNull(), // "bookings", "vehicles", "invoices"
  recordId: text("record_id").notNull(), // document ID
  userId: text("user_id").notNull(), // user ที่ถูกแชร์ให้
  canRead: integer("can_read").notNull().default(1), // 1 = can read
  canWrite: integer("can_write").notNull().default(0), // 1 = can write
  sharedBy: text("shared_by").notNull(), // user ID ที่แชร์
  note: text("note"), // optional note
  expiresAt: text("expires_at"), // nullable = no expiry (ISO string)
  companyId: text("company_id").notNull(),
  createdAt: text("created_at").notNull(),
}, (table) => ({
  uniqueIdx: uniqueIndex("rs_unique_idx").on(table.module, table.doctype, table.recordId, table.userId),
  recordIdx: index("rs_record_idx").on(table.module, table.doctype, table.recordId),
  userIdx: index("rs_user_idx").on(table.userId, table.module),
}));

// Type exports
export type RecordShare = typeof recordShares.$inferSelect;
export type NewRecordShare = typeof recordShares.$inferInsert;
